// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toBagButton":"toBagButton_LHRGf"};